import React from 'react';
import { withStyles, WithStyles } from '@material-ui/core/styles';
import { ILumaBotFlowMessagesHistory, ELumaBotFlowMessagesHistorySource } from 'ui-model';
import { IconAvatarLumaBot } from 'icons';
import classnames from 'classnames';
import moment from 'moment';
import Typography from '../../../Typography';

import styles from './SessionMessage.styles';

interface ISessionMessage extends WithStyles<typeof styles> {
  message: ILumaBotFlowMessagesHistory;
}

const SessionMessage: React.FC<ISessionMessage> = ({ classes, message }) => {
  const { text, createdAt, source } = message;
  const isLumaBotMessage = source === ELumaBotFlowMessagesHistorySource.LumaBot;

  return (
    <div className={classnames(classes.root, { [classes.reverse]: !isLumaBotMessage })}>
      {isLumaBotMessage && <IconAvatarLumaBot className={classes.avatar} />}
      <div className={classnames(classes.container, { [classes.reverse]: !isLumaBotMessage })}>
        <Typography className={classes.text} component="div" variant="bW500F15" id={`${source}@${createdAt}`}>
          {text}
        </Typography>
        <Typography className={classes.timeStamp} component="div" variant="caption" color="supportSteel">
          {moment(createdAt).format('LT')}
        </Typography>
      </div>
    </div>
  );
};

export default withStyles(styles)(SessionMessage);
